import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';
import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import { hideNumber } from '../../helpers/titreHelper';

import hum from '../../assets/images/channel-none.png';

const Message = ({ className, message }) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  useScrollText(contentRef, contentContainerRef, message?.content);

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  return (
    <div className={cn(styles['wrapper'], className)}>
      {message?.content && (
        <>
          <div className={styles['avatar']}>
            <img
              src={
                (message?.image && message?.image !== '1' && message?.image) ||
                iconsSources[message?.channel]
              }
              alt={message?.author}
              onError={errorHandler}
            />
          </div>
          <div className={styles['content']}>
            <div className={styles['name']}>
              {message?.author || hideNumber(message?.senderNumber)}
            </div>
            <div className={styles['text-wrapper']} ref={contentContainerRef}>
              <div className={styles['text']} ref={contentRef}>
                {message?.content}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
